<template>
  <div>
    <van-dialog
      v-model="show"
      title="注意事项"
      style="margin-top: 30px"
      message="
      本页面仅供以下情况导致无法加入钉钉学生组织的同学登记手机号并自动加入组织
      - 2021新生手机号上报，自动加入钉钉组织
      - 健康打卡预留手机号与本人常用钉钉账号手机号不一致(包含填错等情况)，需要换号
      - 健康打卡手机号正确但未收到加入钉钉组织邀请
      - 加入学生组织后退出，需要重新加入
      - 其他可能无法加入钉钉组织的情况
      如果提交后显示用户信息不存在或用户班级不存在的提示，请勿再次发起申请，后台会自动检查您的数据并修正，请过几小时之后再重试
      如您原先已经有账号在学生组织中，则原先账号将会被移除出组织，所在部门群、内部群也会被退出，学生新账号加入后仅保留班级部门群(如有年级群，则也会保留)，如有需要，请备份相关文件资料后再操作
      "
      message-align="left"
      confirm-button-text="确认需要重新提交手机号"
    >
    </van-dialog>
    <van-nav-bar
      title="钉钉杭电学生组织手机号上报"
      right-text="登出"
      @click-right="handleLogout"
    />
    <van-notice-bar
      wrapable
      :scrollable="false"
      color="#1989fa"
      background="#ecf9ff"
      left-icon="info-o"
    >
      手机号换绑请在钉钉设置-我的信息中进行修改
    </van-notice-bar>
    <van-cell-group>
      <van-cell title="姓名" :value="info.staffName" />
      <van-cell title="学号" :value="info.staffId" />
    </van-cell-group>
    <van-notice-bar left-icon="fail">
      请输入11位手机号码，如为境外号码，请按照 +1-123456 格式输入
    </van-notice-bar>
    <van-form @submit="onSubmit">
      <van-field
        v-model="phone"
        name="手机号码"
        label="手机号码"
        placeholder="请输入钉钉绑定的手机号"
      />
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
    <p class="bottom-msg">如果有问题请加入杭电助手新生答疑群 726855751 解决</p>
  </div>
</template>

<script>
import axios from 'axios'
import {
  CellGroup,
  Field,
  Cell,
  Button,
  Dialog,
  Form,
  NavBar,
  NoticeBar,
} from 'vant'
export default {
  name: 'home',
  components: {
    [Form.name]: Form,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [NavBar.name]: NavBar,
    [NoticeBar.name]: NoticeBar,
    'van-dialog': Dialog.Component,
  },
  data() {
    return {
      info: {},
      phone: '',
      token: '',
      show: true,
    }
  },
  methods: {
    async auth() {
      const token = localStorage.getItem('hduhelp-token')
      this.token = token
      if (token !== null) {
        const personInfoRes = await axios.get('/salmon_base/person/info', {
          headers: {
            Authorization: `token ${token}`,
          },
        })
        this.info = personInfoRes.data.data
      } else {
        this.$router.push('/choose')
      }
    },
    async onSubmit() {
      Dialog.confirm({
        title: '注意',
        message: `请确所填写的手机号 ${this.phone} 准确无误，点击确认后您将会使用此手机号加入学生组织`,
      })
        .then(() => {
          if (
            !/^1[3456789]\d{9}$/.test(this.phone) &&
            !/^\+[0-9]+-[0-9]+$/.test(this.phone)
          ) {
            Dialog.alert({
              message: '手机号输入有误，请重试',
            })
            return
          }
          let data = { Phone: this.phone }
          axios
            .post('/workflow/contact/student', JSON.stringify(data), {
              headers: {
                Authorization: `token ${this.token}`,
              },
            })
            .then(
              (res) => {
                if (res.status !== 200) {
                  this.errMsg = res.msg
                } else {
                  Dialog.alert({
                    message:
                      '您的手机号已更换完成，如号码无误，您将会在钉钉中收到加入组织提示；如仍未加入组织，请按照底部提示加入杭电助手答疑群并出示报错截图',
                  })
                }
              },
              (err) => {
                Dialog.alert({
                  title: '提交失败',
                  message: `${err.response.data.msg}`,
                }).then(() => {
                  if (
                    err.response.data.msg &&
                    err.response.data.msg.trim() === 'unauthorized'
                  ) {
                    localStorage.removeItem('hduhelp-token')
                    this.$router.push('/choose')
                  }
                })
              }
            )
        })
        .catch(() => {})
    },
    handleLogout() {
      localStorage.removeItem('hduhelp-token')
      this.$router.push('/choose')
    },
  },
  async created() {
    await this.auth()
  },
}
</script>

<style>
p {
  margin-left: 10px;
  margin-right: 10px;
}
.bottom-msg {
  margin: 0;
  width: 100%;
  position: absolute;
  bottom: 4px;
  color: #323233;
  font-size: 14px;
  text-align: center;
}
</style>
